import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { UserData } from "../types/responseTypes";
import { GrayBorderBox } from "./boxes";
import { LeftBoxTitle, LeftBoxSubTitle } from "./texts";
import { GrayButton, BlueButton } from "./buttons";

import validateCookie from "../views/Login/validateCookie";

interface LoginFormProps {
    method: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    w?: string;
    h?: string;
}

export const LoginForm: React.FC<LoginFormProps> = ({ method, onChange, w, h }) => {
    const placeholder = method === "email" ? "Ingresa tu correo Ruuf" : "Ingresa tu número Ruuf";
    if (method === "email") {
        return (
            <input
                placeholder={placeholder}
                onChange={onChange}
                required
                type="email"
                style = {{
                    width: w || "100%",
                    height: h || "18%",
                    borderRadius: "16px",
                    backgroundColor: "#F3F4F6"
                }}
                className="p-[5%]"
            />
        );
    }
    else if (method === "whatsapp") {
        return (
            <input
                placeholder={placeholder}
                onChange={onChange}
                required
                type="tel"
                style = {{
                    width: w || "100%",
                    height: h || "18%",
                    borderRadius: "16px",
                    backgroundColor: "#F3F4F6"
                }}
                className="p-[5%]"
            />
        );
    }
    else if (method === "link") {
        return (
            <input
                placeholder="Copia el link aquí"
                onChange={onChange}
                required
                type="text"
                style = {{
                    width: w || "100%",
                    height: h || "18%",
                    borderRadius: "16px",
                    backgroundColor: "#F3F4F6"
                }}
                className="p-[5%]"
            />
        );
    }
    return null;
}

interface EditUserNameFormProps {
    userData: UserData;
    editUserName: (newFirstName: string, newLastName: string) => void;
}

export const EditUserNameForm: React.FC<EditUserNameFormProps> = ({
  userData,
  editUserName,
}) => {
  const userName = `${userData.firstName} ${userData.lastName}`;
  const [isEditing, setIsEditing] = useState(false);
  const [newFirstName, setNewFirstName] = useState(userData.firstName);
  const [newLastName, setNewLastName] = useState(userData.lastName);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    editUserName(newFirstName, newLastName);
    setIsEditing(false);
  };

  return (
    <GrayBorderBox>
      {/* Title and Edit button */}
      <div className="flex justify-between items-center">
        <div>
          <LeftBoxTitle> Nombre: </LeftBoxTitle>
          <LeftBoxSubTitle> {userName} </LeftBoxSubTitle>
        </div>
        {!isEditing && (
          <GrayButton
            onClick={handleEditClick}
            label="Editar"
            w="120px"
            h="44px"
          />
        )}
      </div>

      {/* Edit form */}
      {isEditing && (
        <form onSubmit={handleSubmit} className="mt-4">
          <input
            placeholder="Ingresa tu nuevo nombre"
            // value={newFirstName}
            onChange={(e) => setNewFirstName(e.target.value)}
            required
            type="text"
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "16px",
              backgroundColor: "#F3F4F6",
            }}
            className="p-[5%] mb-2"
          />
          <input
            placeholder="Ingresa tu nuevo apellido"
            // value={newLastName}
            onChange={(e) => setNewLastName(e.target.value)}
            required
            type="text"
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "16px",
              backgroundColor: "#F3F4F6",
            }}
            className="p-[5%] mb-4"
          />
          <BlueButton
            type="submit"
            label="Confirmar Cambios"
            w="395px"
            h="44px"
          />
        </form>
      )}
    </GrayBorderBox>
  );
};

interface EditUserPhoneFormProps {
    userData: UserData;
    editUserPhone: (newPhone: string) => Promise<number>;
    bookingIndex: number;
}

export const EditUserPhoneForm: React.FC<EditUserPhoneFormProps> = ({
  userData,
  editUserPhone,
  bookingIndex,
}) => {
  const navigate = useNavigate();
  const userPhone = userData.phone
  const [isEditing, setIsEditing] = useState(false);
  const [newPhone, setNewPhone] = useState(userData.phone);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await editUserPhone(newPhone);
    if (result === 1) {
      const newUserData = await validateCookie();
      if (newUserData){
        navigate("/edituser", { state: { userData: newUserData, bookingIndex } });
      }
    }
    setIsEditing(false);
  };

  return (
    <GrayBorderBox>
      {/* Title and Edit button */}
      <div className="flex justify-between items-center">
        <div>
          <LeftBoxTitle> Teléfono: </LeftBoxTitle>
          <LeftBoxSubTitle> {userPhone} </LeftBoxSubTitle>
        </div>
        {!isEditing && (
          <GrayButton
            onClick={handleEditClick}
            label="Editar"
            w="120px"
            h="44px"
          />
        )}
      </div>

      {/* Edit form */}
      {isEditing && (
        <form onSubmit={handleSubmit} className="mt-4">
          <input
            placeholder="Ingresa tu nuevo número"
            // value={newPhone}
            onChange={(e) => setNewPhone(e.target.value)}
            required
            type="text"
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "16px",
              backgroundColor: "#F3F4F6",
            }}
            className="p-[5%] mb-2"
          />
          <BlueButton
            type="submit"
            label="Confirmar Cambios"
            w="395px"
            h="44px"
          />
        </form>
      )}
    </GrayBorderBox>
  );
};

interface EditUserEmailFormProps {
    userData: UserData;
    editUserEmail: (newEmail: string) => Promise<number>;
    bookingIndex: number;
}

export const EditUserEmailForm: React.FC<EditUserEmailFormProps> = ({
  userData,
  editUserEmail,
  bookingIndex,
}) => {
  const navigate = useNavigate();
  const userEmail = userData.email
  const [isEditing, setIsEditing] = useState(false);
  const [newEmail, setNewEmail] = useState(userData.email);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await editUserEmail(newEmail);
    if (result === 1) {
      const newUserData = await validateCookie();
      if (newUserData){
        navigate("/edituser", { state: { userData: newUserData, bookingIndex } });
      }
    }
    setIsEditing(false);
  };

  return (
    <GrayBorderBox>
      {/* Title and Edit button */}
      <div className="flex justify-between items-center">
        <div>
          <LeftBoxTitle> Correo: </LeftBoxTitle>
          <LeftBoxSubTitle> {userEmail} </LeftBoxSubTitle>
        </div>
        {!isEditing && (
          <GrayButton
            onClick={handleEditClick}
            label="Editar"
            w="120px"
            h="44px"
          />
        )}
      </div>

      {/* Edit form */}
      {isEditing && (
        <form onSubmit={handleSubmit} className="mt-4">
          <input
            placeholder="Ingresa tu nuevo correo"
            // value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            required
            type="text"
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "16px",
              backgroundColor: "#F3F4F6",
            }}
            className="p-[5%] mb-2"
          />
          <BlueButton
            type="submit"
            label="Confirmar Cambios"
            w="395px"
            h="44px"
          />
        </form>
      )}
    </GrayBorderBox>
  );
};